import React from "react";
import { useRecordContext } from "react-admin";
import NewCustomerIcon from "./NewCustomerIcon";

export const NameField = ({ source }) => {
  const record = useRecordContext();

  return (
    <span>
      {record[source]}
      <NewCustomerIcon createdAt={record.createdAt} />
    </span>
  );
};

export default NameField;
